import { render, staticRenderFns } from "./gFloatBtn.vue?vue&type=template&id=541173ac&scoped=true"
import script from "./gFloatBtn.vue?vue&type=script&lang=js"
export * from "./gFloatBtn.vue?vue&type=script&lang=js"
import style0 from "./gFloatBtn.vue?vue&type=style&index=0&id=541173ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541173ac",
  null
  
)

export default component.exports